import React from 'react'

function DT2() {
    return (
        <div>
            <h2>DT2</h2>
        </div>
    )
}

export default DT2
